<template>
  <div class="inbox-page">
    <!-- 侧边导航栏 -->
    <el-aside width="20%" class="sidebar">
      <div class="user-profile">
        <el-avatar :size="60" :src="user.avatarimg | avatar"></el-avatar>
        <h3 class="username">{{ user.name }}</h3>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        router
      >
        <el-menu-item index="/about-me/profile">
          <i class="el-icon-message"></i>
          <span>{{ $t("basicInfo1") }}</span>
        </el-menu-item>
        <el-menu-item index="/about-me/merchant-auth">
          <i class="el-icon-star-on"></i>
          <span>{{ $t("merchantAuth") }}</span>
        </el-menu-item>
        <el-submenu index="/about-me/my-listings">
          <template #title>
            <i class="el-icon-location"></i>
            <span>{{ $t("myListings") }}</span>
          </template>
          <el-menu-item index="/about-me/my-listings/tourist-lists">
            {{ $t("routeTemplate") }}
          </el-menu-item>
          <el-menu-item index="/about-me/my-listings/order-list">
            {{ $t("orderList") }}
          </el-menu-item>
          <el-menu-item index="/about-me/my-listings/favorite-list">
            {{ $t("favoriteList") }}
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <!-- 主内容区 -->
    <el-main class="main-content">
      <router-view />
    </el-main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {},
    };
  },
  created() {
    const userInfo = this.$cookies.get("userInfo");
    if (userInfo) {
      this.user.name = userInfo.name;
      this.user.avatarimg = userInfo.avatarimg;
    }
    if (this.$route.path === "/about-me") {
      this.$router.push("/about-me/profile");
    }
  },
  computed: {
    activeMenu() {
      const path = this.$route.path;
      if (path === "/about-me/phone-edit" || path === "/about-me") {
        return "/about-me/profile";
      } else if (path === "/about-me/merchant-auth-upload") {
        return "/about-me/merchant-auth";
      } else if (path === "/about-me/my-listings/evaluation") {
        return "/about-me/my-listings/order-list";
      }
      return path;
    },
  },
  methods: {},
};
</script>

<style scoped>
.inbox-page {
  display: flex;
  min-height: 100vh;
}
.sidebar {
  background-color: #f5f7fa;
  padding: 20px;
  border-right: 1px solid #ebeef5;
}
.user-profile {
  text-align: center;
  margin-bottom: 30px;
}
.username {
  font-size: 18px;
  font-weight: 500;
  margin: 10px 0 5px;
}
.user-role {
  font-size: 14px;
  color: #909393;
  margin: 0;
}
.main-content {
  flex: 1;
  padding: 20px;
}
.message-container {
  max-width: 500px;
  text-align: center;
  padding: 20px;
}
.heading {
  font-size: 28px;
  color: #303133;
  margin-bottom: 20px;
}
.description {
  font-size: 16px;
  color: #606266;
  line-height: 1.5;
  margin-bottom: 30px;
}
.download-buttons {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 40px;
}
.phone-preview {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}
::v-deep .el-form-item__label {
  text-align: left;
}
@media (max-width: 768px) {
  .inbox-page {
    flex-direction: column;
  }
  .sidebar {
    width: 100% !important;
    height: auto;
    padding: 15px;
  }
  .el-menu-vertical-demo {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #ebeef5;
  }
  .el-menu-item,
  .el-submenu {
    flex: 1 1 50%;
    min-width: 120px;
  }
  .el-submenu .el-menu {
    position: static !important;
    border: none;
  }
  .main-content {
    padding: 10px 0px;
  }
  .download-buttons {
    flex-direction: row;
    justify-content: center;
  }
}
</style>
